import { plural, t } from '@lingui/core/macro';
import { Alert, Box } from '@pocketlaw/tetris';
export function DocumentProjectAccess(props) {
    const { projectCount = 0 } = props;
    if (projectCount === 0) {
        return null;
    }
    return (<Box my="md">
      <Alert appearance="info" message={t({
            message: plural(projectCount, {
                one: 'This document is included in # project. Users and teams in this project have access in addition to those listed below.',
                other: 'This document is included in # projects. Users and teams in these projects have access in addition to those listed below.',
            }),
            comment: 'Access management - document project access alert message',
        })}/>
    </Box>);
}
